/**
 * Shared constants for scanner components
 */

/**
 * Query parameters that trigger a refresh in scanner-chart.
 * Also used as the cache key for ScannerScoreStateService.
 */
export const SCANNER_REFRESH_PARAMS = [
  'update',
  'tag',
  'updatePayload',
  'type',
  'id',
  'event_ids',
  'eventid',
  'time',
  'lang',
  'feed',
  'categories',
  'continents',
  'countries',
  'factuality',
  'temporality',
  'ranks',
  'panels',
  'period',
  'focused_score',
  'timeframe',
  'updateScores',
  'updateScoresOnSave',
] as const;

export type ScannerRefreshParam = (typeof SCANNER_REFRESH_PARAMS)[number];

/**
 * Query parameters that trigger a refresh in scanner-insights.
 * Excludes event-related params (eventid, event_ids) since insights
 * handles event selection locally without needing a full data reload.
 */
export const SCANNER_INSIGHTS_REFRESH_PARAMS = [
  'update',
  'tag',
  'updatePayload',
  'type',
  'id',
  'time',
  'lang',
  'feed',
  'categories',
  'continents',
  'countries',
  'factuality',
  'temporality',
  'ranks',
  'panels',
  'period',
  'updateScores',
  'updateScoresOnSave',
] as const;

export type ScannerInsightsRefreshParam =
  (typeof SCANNER_INSIGHTS_REFRESH_PARAMS)[number];

/**
 * Query parameters that trigger a full data refresh in scanner-items.
 * More comprehensive than chart/insights as items need portfolio data.
 */
export const SCANNER_ITEMS_REFRESH_PARAMS = [
  'id',
  'update',
  'updateScoresOnSave',
  'time',
  'lang',
  'feed',
  'categories',
  'continents',
  'countries',
  'factuality',
  'temporality',
  'ranks',
  'panels',
] as const;

export type ScannerItemsRefreshParam =
  (typeof SCANNER_ITEMS_REFRESH_PARAMS)[number];

/**
 * Query parameters that trigger column filter updates in scanner-items.
 */
export const SCANNER_ITEMS_COLUMN_REFRESH_PARAMS = [
  'update',
  'updateScoresOnSave',
  'updateScores',
] as const;

export type ScannerItemsColumnRefreshParam =
  (typeof SCANNER_ITEMS_COLUMN_REFRESH_PARAMS)[number];

/**
 * Query parameters that trigger flag updates in scanner-items.
 */
export const SCANNER_ITEMS_FLAG_REFRESH_PARAMS = ['updateFlag'] as const;

export type ScannerItemsFlagRefreshParam =
  (typeof SCANNER_ITEMS_FLAG_REFRESH_PARAMS)[number];
